import React, { useState, useMemo, useCallback } from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import Sidebar from '../Layout/Sidebar';
import Navbar from '../Layout/Navbar';
import AppKeys from '../Sections/AppKeys';
// import Templates from '../Sections/Templates';
import EsignRequests from '../Sections/EsignRequests';
import SignerForm from '../DemoForm/SignerForm';

const Dashboard = ({ onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Memoize routes
  const routes = useMemo(() => [
    { path: "app-keys", element: <AppKeys /> },
    // { path: "templates", element: <Templates /> },
    { path: "documents", element: <EsignRequests /> },
    { path: "demo-screen", element: <SignerForm /> },
  ], []);

  const [activeSection, setActiveSection] = useState(() => {
    const path = location.pathname.split('/').pop();
    return path || 'app-keys';
  });

  const handleSectionChange = useCallback((sectionId) => {
    if (sectionId === activeSection) return;
    setActiveSection(sectionId);
    navigate(`/dashboard/${sectionId}`);
  }, [activeSection, navigate]);

  return (
    <div className="h-screen flex flex-col">
      <Navbar onLogout={onLogout} />
      <div className="flex-1 flex overflow-hidden">
        <aside className="w-64 flex-shrink-0"> 
          <Sidebar 
            activeSection={activeSection} 
            onSectionChange={handleSectionChange} 
          />
        </aside>
        <main className="flex-1 overflow-y-auto bg-gray-50"> 
          <div className="p-8">
            <Routes>
              {routes.map(({ path, element }) => (
                <Route key={path} path={path} element={element} />
              ))}
              <Route path="" element={<Navigate to="app-keys" replace />} />
            </Routes>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Dashboard;